import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { urls } from "../configs/serviceConfig";
import { authorizationHeaders } from "./authorizationHeaders";
import { ProgrammeStep } from "../types/ProgrammeOverview";

interface GetProgrammeStepRequest {
  programmeId: string;
  stepNumber: number;
}

export const programmeStepApi = createApi({
  reducerPath: "programmeStepApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${urls.programmeService}/`,
    prepareHeaders: authorizationHeaders,
  }),

  endpoints: (builder) => ({
    getProgrammeStep: builder.query<ProgrammeStep, GetProgrammeStepRequest>({
      query: (data) => {
        return `/programme/${data.programmeId}/step/${data.stepNumber}`;
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProgrammeStepQuery } = programmeStepApi;
